module.exports = __webpack_public_path__ + "media/honey-icons/icon-down-arrow-43a6044a.svg";